import {
  takeLatest,
  put,
  putResolve,
  select,
} from 'redux-saga/effects';

import { actionAddException } from 'react-redux-app/lib/modules/exception/actions';
import { actionLoadBalanceRequest } from '../actions/balance';

import { maybeHandleCriticalErrorWithHistory } from 'react-redux-app/lib/modules/api/utils';

import {
  ACTION_CANCEL_PAYOUT_REQUEST__SUCCESS,
  ACTION_CREATE_PAYOUT_REQUEST__SUCCESS,
} from '../../payout/actionTypes';

import { getLoadBalanceError } from '../selectors';


function* reloadWebmasterBalance(history) {
  try {
    yield putResolve(actionLoadBalanceRequest());

    const error = yield select(getLoadBalanceError);
    maybeHandleCriticalErrorWithHistory(history, error?.globalErrors);
  } catch (e) {
    yield put(actionAddException(e));
  }
}

export default function* saga(history) {
  yield takeLatest([
    ACTION_CANCEL_PAYOUT_REQUEST__SUCCESS,
    ACTION_CREATE_PAYOUT_REQUEST__SUCCESS,
  ], reloadWebmasterBalance, history);
}
